import type { AuthorizedResourceAccessMap } from '@/permissions/adapter';
import { getAllPermissionKeys, PERMISSION_RESOURCE_CODES } from '@/permissions/definitions';

type AccessInitialState = {
  authorizedResourceAccess?: AuthorizedResourceAccessMap;
  currentTenantIsAdmin?: boolean;
};

export default function access(
  initialState?: AccessInitialState,
): AuthorizedResourceAccessMap {
  const permissionKeys = [
    ...getAllPermissionKeys(),
    ...Object.values(PERMISSION_RESOURCE_CODES).flatMap((resourceCode) => [
      `${resourceCode}:view`,
      `${resourceCode}:query`,
      `${resourceCode}:search`,
      `${resourceCode}:filter`,
    ]),
  ];
  const defaults = permissionKeys.reduce<AuthorizedResourceAccessMap>(
    (result, key) => ({ ...result, [key]: false }),
    {},
  );

  if (initialState?.currentTenantIsAdmin) {
    return permissionKeys.reduce<AuthorizedResourceAccessMap>(
      (result, key) => ({ ...result, [key]: true }),
      { ...(initialState.authorizedResourceAccess || {}) },
    );
  }

  const authorizedResourceAccess = initialState?.authorizedResourceAccess || {};
  const resourceReadAccess = Object.values(PERMISSION_RESOURCE_CODES).reduce<AuthorizedResourceAccessMap>(
    (result, resourceCode) => {
      if (!authorizedResourceAccess[resourceCode]) {
        return result;
      }
      return {
        ...result,
        [`${resourceCode}:view`]: true,
        [`${resourceCode}:query`]: true,
        [`${resourceCode}:search`]: true,
        [`${resourceCode}:filter`]: true,
      };
    },
    {},
  );

  return { ...defaults, ...resourceReadAccess, ...authorizedResourceAccess };
}
